import api from '../../api'

export const getMenus = () => {
  return api.get('/cms/menus')
}

export const getMenusById = (id) => {
  return api.get(`/cms/menus/${id}`)
}
